import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { AdminService } from "../services/admin.service";

@Injectable({
  providedIn: 'root'
})
export class AdminResolver implements Resolve<boolean> {

  constructor(private service: AdminService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}

@Injectable({
  providedIn: 'root'
})
export class AdminResolverId {

  constructor(private service: AdminService) { }

  getById(id:number): Observable<any> {
    return this.service.getById(id);
  }
  getByIdAndType(id:number, type:string): Observable<any> {
    return this.service.getByIdAndType(id, type);
  }
}